import { render, staticRenderFns } from "./ItemCollectionModal.vue?vue&type=template&id=f7a8f2b4&scoped=true"
import script from "./ItemCollectionModal.vue?vue&type=script&lang=js"
export * from "./ItemCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./ItemCollectionModal.vue?vue&type=style&index=0&id=f7a8f2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a8f2b4",
  null
  
)

export default component.exports